import { useParams } from "react-router";
import { RouteParams } from "@ui/navigation/routes";

export function useRouteParams<R extends keyof RouteParams>(): Partial<RouteParams[R]> {
	return useParams() as Partial<RouteParams[R]>;
}
